import { render, staticRenderFns } from "./BaseMenu.vue?vue&type=template&id=58ffd4f0"
import script from "./BaseMenu.vue?vue&type=script&lang=js"
export * from "./BaseMenu.vue?vue&type=script&lang=js"
import style0 from "./BaseMenu.vue?vue&type=style&index=0&id=58ffd4f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports